import React, { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Switch,
} from "@material-ui/core";
import {
  Group,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  AddCircle,
  CheckCircle as CheckCircleIcon,
  ChatBubble as ChatBubbleIcon,
} from "@material-ui/icons";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CancelIcon from '@material-ui/icons/Cancel';

import { FilterAltOff, FilterAlt } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter"; // corrigido caminho
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => {
  const isDark = (theme.palette.type || theme.palette.mode) === 'dark';
  return {
    ticketsWrapper: {
      position: "relative",
      display: "flex",
      height: "100%",
      flexDirection: "column",
      overflow: "hidden",
      borderRadius: 12,
      border: "none",
    },

    tabsHeader: {
      minWidth: "auto",
      width: "auto",
      borderRadius: 8,
      marginTop: 0,
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      userSelect: "none",
    },
    settingsIcon: {
      alignSelf: "center",
      marginLeft: "auto",
      padding: theme.spacing(1),
    },
    tab: {
      minWidth: "auto",
      width: "auto",
      padding: theme.spacing(0.4, 0.8),
      borderRadius: 8,
      transition: "0.3s",
      border: "none",
      marginRight: 0,
      marginLeft: 0,
      [theme.breakpoints.down("lg")]: {
        fontSize: "0.9rem",
        padding: theme.spacing(0.35, 0.65),
        marginRight: 0,
        marginLeft: 0,
      },
      [theme.breakpoints.down("md")]: {
        fontSize: "0.8rem",
        padding: theme.spacing(0.3, 0.5),
        marginRight: 0,
        marginLeft: 0,
      },
      "&:hover": {
        backgroundColor: theme.palette.action.hover, // substitui rgba fixo
      },
    },

    tabSelected: {
      backgroundColor: theme.palette.action.selected,
      boxShadow: `inset 0 -2px 0 ${theme.palette.primary.main}`,
      transition: "background-color 220ms ease, box-shadow 220ms ease",
    },

    tabLabelRoot: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 0,
      gap: 8,
    },

    iconWithBadge: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 28,
    },

    tabIcon: {
      fontSize: 22,
      color: isDark ? 'rgba(255,255,255,0.65)' : theme.palette.text.secondary,
      [theme.breakpoints.down("md")]: {
        fontSize: 20,
      },
    },

    badgePill: {
      marginLeft: 6,
      padding: "0px 8px",
      height: 18,
      lineHeight: "18px",
      fontSize: 11,
      borderRadius: 8,
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.down("md")]: {
        fontSize: 10,
        height: 16,
        lineHeight: "16px",
        padding: "0px 6px",
      },
    },

    tabText: {
      overflow: "hidden",
      whiteSpace: "nowrap",
      transition: "max-width 220ms ease, opacity 220ms ease, transform 220ms ease, margin-left 220ms ease",
      fontSize: 12,
      fontWeight: 600,
      [theme.breakpoints.down("md")]: {
        fontSize: 11,
      },
    },
    tabTextHidden: {
      opacity: 0,
      transform: "translateX(-6px)",
      maxWidth: 0,
      marginLeft: 0,
    },
    tabTextActive: {
      opacity: 1,
      transform: "translateX(0)",
      maxWidth: 160,
      marginLeft: 4,
      color: isDark ? '#FFF' : theme.palette.primary.main,
      [theme.breakpoints.down("md")]: {
        maxWidth: 120,
      },
    },

    tabPanelItem: {
      minWidth: "auto",
      flex: "initial",
      fontSize: 12,
      margin: 0,
      padding: "4px 10px",
      color: theme.palette.primary.main,
      textTransform: "none",
      opacity: 0.9,
      position: "relative",
      '&:not(:last-child)': {
        paddingRight: 12,
        [theme.breakpoints.down("md")]: {
          paddingRight: 10,
        },
      },
      '&:not(:last-child)::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        width: 2,
        height: 14,
        backgroundColor: theme.palette.divider,
        borderRadius: 1,
        pointerEvents: 'none',
        [theme.breakpoints.down("md")]: {
          height: 12,
        },
      },
    },

    // Indicador padrão (usado em outros lugares)
    tabIndicator: {
      height: 6,
      bottom: 0,
      borderRadius: "0 0 8px 8px",
      marginButton: "15px",
      backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    // Indicador do estilo "pill" (barra branca curtinha)
    pillTabIndicator: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent !important",
      height: 0,
    },
    pillTabIndicatorInner: {
      width: 28,
      height: 3,
      backgroundColor: theme.palette.primary.main,
      borderRadius: 2,
      marginTop: 3,
    },
    tabsFlex: {
      justifyContent: "center",
      alignItems: "center",
    },
    // Container externo para centralizar o grupo de abas
    pillsOuter: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      margin: theme.spacing(0.5, 0, 1),
    },
    // Wrapper arredondado que envolve as abas
    pillsPaper: {
      display: "inline-flex",
      backgroundColor: theme.palette.background.paper,
      borderRadius: 24,
      padding: theme.spacing(0.5),
      border: `1px solid ${theme.palette.divider}`,
    },
    // Estado selecionado para as abas "pill"
    pillTabSelected: {
      opacity: 1,
      backgroundColor: "transparent",
      '& $tabIcon': {
        color: isDark ? '#FFF' : theme.palette.primary.main,
      },
      '& $tabTextPrimary': {
        color: isDark ? '#FFF' : theme.palette.primary.main,
      },
    },
    // Texto da aba na cor do tema
    tabTextPrimary: {
      color: isDark ? 'rgba(255,255,255,0.65)' : theme.palette.text.secondary,
    },
    tabsBadge: {
      top: "105%",
      right: "55%",
      transform: "translate(45%, 0)",
      whiteSpace: "nowrap",
      borderRadius: "12px",
      padding: "0 8px",
      backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
    },
    ticketOptionsBox: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      background: "transparent",
      borderRadius: 8,
      border: "none",
      marginTop: 0,
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      padding: theme.spacing(0.5),
      userSelect: "none",
    },

    serachInputWrapper: {
      flex: 1,
      height: 40,
      background: "transparent",
      display: "flex",
      borderRadius: 40,
      padding: 4,
      borderColor: "#e8e8e8",
      borderWidth: "1px",
      borderStyle: "solid",
      margin: "10px 3px 0px 10px",
    },

    searchIcon: {
      color: "grey",
      marginLeft: 6,
      marginRight: 6,
      alignSelf: "center",
    },

    searchInput: {
      flex: 1,
      border: "none",
      borderRadius: 30,
    },

    badge: {
      right: "-10px",
    },

    customBadge: {
      right: "25px",
      backgroundColor: "#f44336",
      color: "#fff",
    },

    show: {
      display: "block",
    },

    hide: {
      display: "none !important",
    },

    closeAllFab: {
      backgroundColor: "red",
      marginBottom: "4px",
      "&:hover": {
        backgroundColor: "darkred",
      },
    },

    speedDial: {
      position: "absolute",
      bottom: "theme.spacing(1)",
      right: theme.spacing(1),
      "& .MuiFab-root": {
        width: "40px",
        height: "40px",
        marginTop: "6px",
      },
      "& .MuiFab-label": {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },

    snackbar: {
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: theme.palette.primary.main,
      color: "white",
      borderRadius: 30,
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.8em",
      },
      [theme.breakpoints.up("md")]: {
        fontSize: "1em",
      },
    },

    yesButton: {
      backgroundColor: "rgb(141, 0, 0)",
      color: "rgb(255, 255, 255)",
      padding: "4px 4px",
      fontSize: "0.7em",
      textTransform: "uppercase",
      marginRight: theme.spacing(1),
      "&:hover": {
        backgroundColor: "rgb(184, 0, 0)",
        color: "rgb(255, 255, 255)",
      },
      borderRadius: 30,
    },
    noButton: {
      backgroundColor: "rgb(0, 148, 32)",
      color: "rgb(255, 255, 255)",
      padding: "6px 8px",
      fontSize: "1em",
      fontWeight: "bold",
      textTransform: "uppercase",
      "&:hover": {
        backgroundColor: "rgb(0, 201, 27)",
        color: "rgb(255, 255, 255)",
      },
      borderRadius: 30,
    },
    filterIcon: {
      marginRight: 6,
      alignSelf: "center",
      color: theme.mode === "light" ? "#0872b9" : "#FFF",
      cursor: "pointer",
    },
    button: {
      height: 30,
      width: 30,
      borderColor: "#aaa",
      borderRadius: 8,
      marginRight: 8,
      "&:hover": {
        borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      },
    },
    icon: {
      color: "#aaa",
      "&:hover": {
        color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      },
    },
    buttonOpen: {
      "& $icon": {
        color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
      },
    },

    // Novos estilos para toggles modernos
    modernToggleWrapper: {
      display: "flex",
      alignItems: "center",
      borderRadius: "25px",
      padding: "4px",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      height: "36px",
      position: "relative",
      userSelect: "none",
      "&:hover": {
        transform: "scale(1.02)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      },
    },

    modernToggleTrack: {
      position: "relative",
      width: "85px",
      height: "32px",
      borderRadius: "16px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 12px",
      boxShadow: "inset 0 2px 4px rgba(0,0,0,0.1)",
    },

    modernToggleThumb: {
      width: "42px",
      height: "24px",
      backgroundColor: "#fff",
      borderRadius: "12px",
      position: "absolute",
      top: "4px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.05)",
      "&:hover": {
        boxShadow: "0 4px 12px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.1)",
      },
    },

    modernToggleIcon: {
      fontSize: "1rem",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      position: "absolute",
      zIndex: 1,
    },

    // Toggle para Abertos/Resolvidos
    statusToggleWrapper: {
      display: "flex",
      alignItems: "center",
      borderRadius: "22px",
      padding: "3px",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      height: "38px",
      position: "relative",
      userSelect: "none",
      "&:hover": {
        transform: "scale(1.02)",
        boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
      },
    },

    statusToggleTrack: {
      position: "relative",
      width: "80px",
      height: "34px",
      borderRadius: "17px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },

    statusToggleThumb: {
      width: "36px",
      height: "28px",
      backgroundColor: "#fff",
      borderRadius: "14px",
      position: "absolute",
      top: "3px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05)",
      zIndex: 2,
    },

    statusToggleLabel: {
      position: "absolute",
      width: "50%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      fontSize: "12px",
      fontWeight: 600,
      zIndex: 1,
    },

    // Botão Novo Atendimento Moderno
    newTicketButton: {
      display: "flex",
      alignItems: "center",
      position: "relative",
      overflow: "hidden",
      borderRadius: "25px",
      cursor: "pointer",
      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
      height: "44px",
      minWidth: "44px",
      margin: "10px 6px 0px 3px",
      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
      boxShadow: `0 4px 15px ${theme.palette.primary.main}40`,
      "&:hover": {
        transform: "scale(1.02)",
        boxShadow: `0 8px 25px ${theme.palette.primary.main}60`,
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
      },
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: "-100%",
        width: "100%",
        height: "100%",
        background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
        transition: "left 0.5s",
      },
      "&:hover::before": {
        left: "100%",
      },
    },

    newTicketButtonExpanded: {
      width: "200px",
    },

    newTicketButtonCollapsed: {
      width: "44px",
    },

    newTicketButtonText: {
      position: "absolute",
      left: "15px",
      right: "55px",
      color: theme.palette.primary.contrastText,
      fontSize: "14px",
      fontWeight: 600,
      whiteSpace: "nowrap",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      zIndex: 1,
      textShadow: "0 1px 2px rgba(0,0,0,0.2)",
    },

    newTicketButtonIcon: {
      position: "absolute",
      right: "6px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(10px)",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      zIndex: 2,
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        transform: "scale(1.1)",
      },
    },

    newTicketIconSvg: {
      fontSize: "20px",
      color: theme.palette.primary.contrastText,
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.2))",
    },

    // Botão Fechar Todas as Conversas
    closeAllButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      backgroundColor: "transparent",
      border: `2px solid ${theme.palette.error.main}`,
      "&:hover": {
        backgroundColor: theme.palette.error.main,
        transform: "scale(1.1)",
        boxShadow: `0 4px 12px ${theme.palette.error.main}40`,
      },
    },

    closeAllButtonHovered: {
      backgroundColor: theme.palette.error.main,
      transform: "scale(1.1)",
      boxShadow: `0 4px 12px ${theme.palette.error.main}40`,
    },

    closeAllIcon: {
      fontSize: "20px",
      color: theme.palette.error.main,
      transition: "color 0.3s ease",
    },

    closeAllIconHovered: {
      color: theme.palette.error.contrastText,
    },

    // Barra de Pesquisa Moderna
    modernSearchWrapper: {
      flex: 1,
      height: "44px",
      background: theme.palette.background.paper,
      display: "flex",
      borderRadius: "24px",
      padding: "0px 8px",
      border: `2px solid ${theme.palette.divider}`,
      margin: "10px 3px 0px 10px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      "&:hover": {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 4px 12px ${theme.palette.primary.main}20`,
        transform: "translateY(-1px)",
      },
      "&:focus-within": {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
        transform: "translateY(-1px)",
      },
    },

    modernSearchIcon: {
      color: theme.palette.text.secondary,
      marginLeft: "8px",
      marginRight: "8px",
      alignSelf: "center",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      fontSize: "1.2rem",
    },

    modernSearchInput: {
      flex: 1,
      border: "none",
      borderRadius: "20px",
      padding: "12px 8px",
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.primary,
      backgroundColor: "transparent",
      "&::placeholder": {
        color: theme.palette.text.secondary,
        opacity: 0.7,
      },
      "&:focus": {
        outline: "none",
      },
    },

    modernSearchSwitch: {
      marginLeft: "8px",
      marginRight: "4px",
      display: "flex",
      alignItems: "center",
      flexShrink: 0,
    },

    modernFilterButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      backgroundColor: "transparent",
      border: "none",
      marginLeft: "4px",
      position: "relative",
      overflow: "hidden",
      flexShrink: 0,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
        transform: "scale(1.05)",
      },
      "&:active": {
        transform: "scale(0.95)",
      },
      "&::before": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        width: "0",
        height: "0",
        borderRadius: "50%",
        background: theme.palette.primary.main,
        opacity: 0.2,
        transform: "translate(-50%, -50%)",
        transition: "all 0.3s ease",
      },
      "&:active::before": {
        width: "100%",
        height: "100%",
      },
    },

    modernFilterIcon: {
      fontSize: "1.3rem",
      color: theme.palette.text.secondary,
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    },

    modernFilterIconActive: {
      color: theme.palette.primary.main,
      transform: "scale(1.1)",
    },

    // Animação de pulso global
    "@global": {
      "@keyframes pulse": {
        "0%": {
          boxShadow: "0 0 0 0 rgba(255, 255, 255, 0.4)",
        },
        "70%": {
          boxShadow: "0 0 0 6px rgba(255, 255, 255, 0)",
        },
        "100%": {
          boxShadow: "0 0 0 0 rgba(255, 255, 255, 0)",
        },
      },
    },
  };
});

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  // const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);
  const [deviceCount, setDeviceCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);
  const [isHoveredCloseAll, setIsHoveredCloseAll] = useState(false);

  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(!forceSearch);
  }, [tab]);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
      // setFilter(false);
      setTab("open");
      return;
    } else if (tab !== "search") {
      handleFilter();
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleBack = () => {

    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  const renderTabLabel = (value, IconComp, count, labelText) => {
    const isActive = tabOpen === value;
  return (
      <div className={classes.tabLabelRoot}>
        <span className={classes.iconWithBadge}>
          <IconComp className={classes.tabIcon} />
          {typeof count === "number" && (
            <span className={classes.badgePill}>{count}</span>
          )}
        </span>
    <Typography className={`${classes.tabText} ${classes.tabTextPrimary} ${isActive ? classes.tabTextActive : classes.tabTextHidden}`}>
          {labelText}
        </Typography>
      </div>
    );
  };


  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (tags.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (users.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (whatsapp.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeout);

    if (statusFilter.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open");
    } else setFilter(true);
    setTab("search");
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
        {/* Barra de Pesquisa Moderna */}
        <div className={classes.modernSearchWrapper}>
          <SearchIcon className={classes.modernSearchIcon} />
          <InputBase
            className={classes.modernSearchInput}
            inputRef={searchInputRef}
            placeholder={i18n.t("tickets.search.placeholder")}
            type="search"
            onChange={handleSearch}
          />
          
          <Tooltip placement="top" title="Marque para pesquisar também nos conteúdos das mensagens (mais lento)">
            <div className={classes.modernSearchSwitch}>
              <Switch
                size="small"
                checked={searchOnMessages}
                onChange={(e) => { setSearchOnMessages(e.target.checked) }}
                color="primary"
              />
            </div>
          </Tooltip>
          
          <Tooltip placement="top" title={isFilterActive ? "Desativar filtros" : "Ativar filtros"}>
            <button
              className={classes.modernFilterButton}
              onClick={() => {
                setIsFilterActive((prevState) => !prevState);
                handleFilter();
              }}
            >
              {isFilterActive ? (
                <FilterAlt className={`${classes.modernFilterIcon} ${classes.modernFilterIconActive}`} />
              ) : (
                <FilterAltOff className={classes.modernFilterIcon} />
              )}
            </button>
          </Tooltip>
        </div>

        {/* Botão Novo Atendimento Moderno */}
        <Tooltip title="Criar novo atendimento/conversa" placement="top">
          <div
            className={`${classes.newTicketButton} ${
              isHoveredNew ? classes.newTicketButtonExpanded : classes.newTicketButtonCollapsed
            }`}
            onMouseEnter={() => setIsHoveredNew(true)}
            onMouseLeave={() => setIsHoveredNew(false)}
            onClick={() => setNewTicketModalOpen(true)}
          >
            <div
              className={classes.newTicketButtonText}
              style={{
                opacity: isHoveredNew ? 1 : 0,
                transform: isHoveredNew ? "translateX(0)" : "translateX(-20px)",
              }}
            >
              Novo Atendimento
            </div>
            
            <div 
              className={classes.newTicketButtonIcon}
              style={{
                animation: isHoveredNew ? "none" : "pulse 2s infinite",
              }}
            >
              <AddCircle 
                className={classes.newTicketIconSvg}
                style={{
                  transform: isHoveredNew ? "rotate(90deg)" : "rotate(0deg)",
                }}
              />
            </div>
          </div>
        </Tooltip>
      </div>





      {filter === true && (
        <>
          <TagsFilter onFiltered={handleSelectedTags} />
          <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
          <StatusFilter onFiltered={handleSelectedStatus} />
          {profile === "admin" && (
            <>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </>
          )}
        </>
      )}

      {/* inicio da barra dos botôes */}

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center" justifyContent="center" style={{ display: "flex", flexWrap: "nowrap", gap: "5px" }}>

          <Snackbar
            open={snackbarOpen}
            onClose={handleSnackbarClose}
            message={i18n.t("tickets.inbox.closedAllTickets")}
            ContentProps={{
              className: classes.snackbar,
            }}
            action={
              <>
                <Button className={classes.yesButton} size="small" onClick={CloseAllTicket}>
                  {i18n.t("tickets.inbox.yes")}
                </Button>
                <Button className={classes.noButton} size="small" onClick={handleSnackbarClose}>
                  {i18n.t("tickets.inbox.no")}
                </Button>
              </>
            }
          />

          <Grid item xs style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", height: "40px" }}>

            <Can
              role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
              perform="tickets-manager:showall"
              yes={() => (
                <Tooltip 
                  title={showAllTickets ? "Clique para ver apenas seus atendimentos" : "Clique para ver todos os atendimentos"} 
                  placement="top"
                >
                  <div
                    className={classes.modernToggleWrapper}
                    onMouseEnter={() => setIsHoveredAll(true)}
                    onMouseLeave={() => setIsHoveredAll(false)}
                    onClick={() => setShowAllTickets((prevState) => !prevState)}
                  >
                    <div
                      className={classes.modernToggleTrack}
                      style={{
                        backgroundColor: showAllTickets 
                          ? theme.palette.primary.main 
                          : theme.palette.action.disabled,
                      }}
                    >
                      <VisibilityOffIcon
                        className={classes.modernToggleIcon}
                        style={{
                          color: showAllTickets ? theme.palette.primary.contrastText : theme.palette.text.disabled,
                          left: "12px",
                          opacity: showAllTickets ? 0.9 : 1,
                        }}
                      />
                      <div
                        className={classes.modernToggleThumb}
                        style={{
                          left: showAllTickets ? "39px" : "4px",
                        }}
                      />
                      <VisibilityIcon
                        className={classes.modernToggleIcon}
                        style={{
                          color: showAllTickets ? theme.palette.primary.contrastText : theme.palette.text.disabled,
                          right: "12px",
                          opacity: showAllTickets ? 1 : 0.9,
                        }}
                      />
                    </div>
                  </div>
                </Tooltip>
              )}
            />


            <TicketsQueueSelect
              selectedQueueIds={selectedQueueIds}
              userQueues={user?.queues}
              onChange={(values) => setSelectedQueueIds(values)}
            />

            <Tooltip 
              title={tab === "open" ? "Clique para ver conversas resolvidas" : "Clique para ver conversas abertas"}
              placement="top"
            >
              <div
                className={classes.statusToggleWrapper}
                onMouseEnter={() => setIsHoveredClosed(true)}
                onMouseLeave={() => setIsHoveredClosed(false)}
                onClick={() => handleChangeTab(null, tab === "open" ? "closed" : "open")}
              >
                <div
                  className={classes.statusToggleTrack}
                  style={{
                    backgroundColor: tab === "open" ? theme.palette.success.main : theme.palette.warning.main,
                  }}
                >
                  <div
                    className={classes.statusToggleLabel}
                    style={{
                      left: "0",
                      color: tab === "open" ? theme.palette.success.contrastText : theme.palette.text.disabled,
                      opacity: tab === "open" ? 0.9 : 1,
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: "18px" }} />
                  </div>
                  
                  <div
                    className={classes.statusToggleThumb}
                    style={{
                      left: tab === "open" ? "3px" : "41px",
                    }}
                  />
                  
                  <div
                    className={classes.statusToggleLabel}
                    style={{
                      right: "0",
                      color: tab === "open" ? theme.palette.text.disabled : theme.palette.warning.contrastText,
                      opacity: tab === "open" ? 1 : 0.9,
                    }}
                  >
                    <ChatBubbleIcon style={{ fontSize: "18px" }} />
                  </div>
                </div>
              </div>
            </Tooltip>

            {user.profile === "admin" && (
              <Tooltip title="Fechar todas as conversas da aba atual" placement="top">
                <div
                  className={`${classes.closeAllButton} ${
                    isHoveredCloseAll ? classes.closeAllButtonHovered : ""
                  }`}
                  onClick={handleSnackbarOpen}
                  onMouseEnter={() => setIsHoveredCloseAll(true)}
                  onMouseLeave={() => setIsHoveredCloseAll(false)}
                >
                  <CancelIcon 
                    className={`${classes.closeAllIcon} ${
                      isHoveredCloseAll ? classes.closeAllIconHovered : ""
                    }`} 
                  />
                </div>
              </Tooltip>
            )}

          </Grid>
        </Grid>
      </Paper>

 {/* xxxxxxxxxxxxxxxx Inicio das guias */}


      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <div className={classes.pillsOuter}>
          <Paper elevation={0} className={classes.pillsPaper}>
            <Tabs
              value={tabOpen}
              onChange={handleChangeTabOpen}
              variant="scrollable"
              scrollButtons="off"
              TabIndicatorProps={{
                className: classes.pillTabIndicator,
                children: <span className={classes.pillTabIndicatorInner} />,
              }}
              classes={{ flexContainer: classes.tabsFlex }}
            >


          
          {/* ATENDENDO */}
          <Tab
            label={
              <Tooltip title={i18n.t("ticketsList.assignedHeader")} enterDelay={2000} placement="top" arrow>
                {renderTabLabel("open", MessageSharpIcon, openCount, i18n.t("ticketsList.assignedHeader"))}
              </Tooltip>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem, selected: classes.pillTabSelected }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Tooltip title={i18n.t("ticketsList.pendingHeader")} enterDelay={2000} placement="top" arrow>
                {renderTabLabel("pending", ClockIcon, pendingCount, i18n.t("ticketsList.pendingHeader"))}
              </Tooltip>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem, selected: classes.pillTabSelected }}
          />

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Tooltip title={i18n.t("ticketsList.groupingHeader")} enterDelay={2000} placement="top" arrow>
                  {renderTabLabel("group", Group, groupingCount, i18n.t("ticketsList.groupingHeader"))}
                </Tooltip>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem, selected: classes.pillTabSelected }}
            />
          )}
          {/* DISPOSITIVO: visível para admin ou usuários com permissão */}
          {(user.profile === "admin" || user.allowDevice === true) && (
            <Tab
              label={
                <Tooltip title="convesas abertas pelo celular" enterDelay={2000} placement="top" arrow>
                  {renderTabLabel("device", SmartphoneIcon, deviceCount, "Dispositivo")}
                </Tooltip>
              }
              value={"device"}
              name="device"
              classes={{ root: classes.tabPanelItem, selected: classes.pillTabSelected }}
            />
          )}
            </Tabs>
          </Paper>
        </div>

 {/* xxxxxxxxxxxxxxxx Fim das guias */}










        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
            />
          )}

          {(user.profile === "admin" || user.allowDevice === true) && (
            <TicketsList
              status="device"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setDeviceCount(val)}
              style={applyPanelStyle("device")}
              setTabOpen={setTabOpen}
            />
          )}
        </Paper>



      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
        />
      </TabPanel>

      
      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
              setTabOpen={(value) => {
                setTabOpen(value);
                handleFilter();
              }}
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
            setTabOpen={(value) => {
              setTabOpen(value);
              handleFilter();
            }}
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;
